export const IconOlx20: {
  name: 'icon_olx_20-facd36c1c797'
} = {
  name: 'icon_olx_20-facd36c1c797'
}
